import { render, staticRenderFns } from "./StudentPetManage.vue?vue&type=template&id=01199ccc&scoped=true"
import script from "./StudentPetManage.vue?vue&type=script&lang=js"
export * from "./StudentPetManage.vue?vue&type=script&lang=js"
import style0 from "./StudentPetManage.vue?vue&type=style&index=0&id=01199ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01199ccc",
  null
  
)

export default component.exports